
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'Case Studies', href: '/case-studies' },
    { name: 'About', href: '/about' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (href: string) => {
    return location.pathname === href;
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-[#2BB6A3] rounded-lg flex items-center justify-center">
              <i className="ri-flashlight-line text-white text-xl"></i>
            </div>
            <span className="text-2xl font-bold text-[#1B365D]" style={{ fontFamily: '"Pacifico", serif' }}>
              SparkBoost Labs
            </span>
          </Link>

          <div className="flex items-center space-x-8">
            <nav className="hidden md:flex items-center space-x-8">
              <a href="/about" className="text-[#2A2D34] hover:text-[#2BB6A3] transition-colors cursor-pointer">
                About
              </a>
              <a href="/services" className="text-[#2A2D34] hover:text-[#2BB6A3] transition-colors cursor-pointer">
                Services
              </a>
              <a href="/case-studies" className="text-[#2A2D34] hover:text-[#2BB6A3] transition-colors cursor-pointer">
                Case Studies
              </a>
              <a href="/blog" className="text-[#2A2D34] hover:text-[#2BB6A3] transition-colors cursor-pointer">
                Blog
              </a>
              <a href="/contact" className="text-[#2A2D34] hover:text-[#2BB6A3] transition-colors cursor-pointer">
                Contact
              </a>
            </nav>
            
            <a 
              href="/book-call"
              className="bg-[#2BB6A3] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#1B365D] transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Book Free Call
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2"
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4 pt-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-medium transition-colors hover:text-[#2BB6A3] ${
                    isActive(item.href) ? 'text-[#2BB6A3]' : 'text-gray-700'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/free-assessment"
                onClick={() => setIsMenuOpen(false)}
                className="bg-[#2BB6A3] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#239B8A] transition-colors text-center whitespace-nowrap"
              >
                Free Assessment
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
